import { queryOptions } from "@tanstack/react-query";

import { getAllFarms } from "../../../generated/api/agroevidence";
import { getFarmUsers } from "../../../generated/api/farmManagement";

import { apiKeys } from "./apiKeys";

const farmsQuery = ({ search }: { search: string }) =>
  queryOptions({
    queryKey: apiKeys.farms.all(search),
    queryFn: ({ signal }) =>
      getAllFarms(
        {
          search,
        },
        {
          signal,
        },
      ),
  });

const farmUsersQuery = ({ farmId }: { farmId: string }) =>
  queryOptions({
    queryKey: apiKeys.farmUsers.all(farmId),
    queryFn: ({ signal }) => getFarmUsers({ farmIds: farmId }, { signal }),
  });

export { farmsQuery, farmUsersQuery };
